import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/GasCheckoutDataProvider";
import FormError from "../../../../shared/forms/FormError";
import NewFormRow from "../../../../shared/forms/NewFormRow";
import NewInput from "../../../../shared/forms/NewInput";
import NewSelect from "../../../../shared/forms/NewSelect";
import Margin from "../../../../shared/Margin";
import NewHeadline from "../../../../shared/NewHeadline";
import Section from "../../../../shared/Section";
import DatePicker from "./DatePicker";

const StepDeliveryDetails = () => {
    const dataContext = useContext(DataContext);

    const { deliveryDetails } = dataContext.data;
    const {
        setDeliveryDetails,
        addFormError,
        clearFormError,
        hasFormErrorAt,
        setFormErrors,
    } = dataContext.actions;

    const handleChange = (event) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ [event.target.name]: event.target.value },
        });
        clearFormError(event.target.name);
    };

    const onChangeMovementDateMoving = (value) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_change_date: value },
        });
        clearFormError("delivery_change_date");
    };

    const selectSupplierTypeHandleChange = (event) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_change_date_immediately: event.target.value },
        });
        setFormErrors([]);
    };
    const movementTypehandleChange = (event) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_movement_type: event.target.value },
        });
        setFormErrors([]);
    };

    const selectTerminateSupplierHandleChange = (event) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_supplier_terminated: event.target.value },
        });
        setFormErrors([]);
    };

    const onChangeMovementDateChSuDate = (value) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_change_date: value },
        });
        setFormErrors([]);
    };

    const onChangeTerminateSupplierDate = (value) => {
        setDeliveryDetails({
            ...deliveryDetails,
            ...{ delivery_supplier_terminated_date: value },
        });
        setFormErrors([]);
    };

    /**
     * Checks if the given date is a weekday and also 2 Days after today.
     * @param {*} date
     */
    const WechselterminAvailableDate = (date) => {
        return date;
    };

    const lieferantelwechselAvailableDate = (date) => {
        // const day = date.getDay();
        // return day !== 0 && day !== 6;
        return date;
    };
    return (
        <React.Fragment>
            <NewHeadline>Ihr Erdgas-Anschluss</NewHeadline>

            <Margin Component={Section} top="10">
                <NewFormRow>
                    <NewFormRow.Label>Wechsel oder Umzug?</NewFormRow.Label>
                    <NewFormRow.Value>
                        <NewSelect
                            name="delivery_movement_type"
                            onChange={movementTypehandleChange}
                            options={[
                                {
                                    value: "Umzug/Einzug",
                                    text: "Umzug/Einzug",
                                },
                                {
                                    value: "Lieferantenwechsel",
                                    text: "Lieferantenwechsel",
                                },
                            ]}
                        />
                    </NewFormRow.Value>
                </NewFormRow>

                <NewFormRow>
                    <NewFormRow.Label>Zählernummer</NewFormRow.Label>
                    <NewFormRow.Value>
                        <NewInput
                            placeholder="Zählernummer"
                            name="delivery_counter_number"
                            onChange={handleChange}
                            value={deliveryDetails.delivery_counter_number}
                            validation="counterNumber"
                            forceError={hasFormErrorAt(
                                "delivery_counter_number"
                            )}
                            onError={() =>
                                addFormError("delivery_counter_number")
                            }
                            onErrorSolved={() =>
                                clearFormError("delivery_counter_number")
                            }
                        />
                    </NewFormRow.Value>
                </NewFormRow>
            </Margin>

            {deliveryDetails.delivery_movement_type === "Umzug/Einzug" && (
                <>
                    <NewFormRow>
                        <NewFormRow.Label>Umzugsdatum</NewFormRow.Label>
                        <NewFormRow.Value>
                            <DatePicker
                                placeholderText="tt.mm.jjjj"
                                value={deliveryDetails.delivery_change_date}
                                onChange={onChangeMovementDateMoving}
                                maxDate={null}
                                minDate={
                                    new Date(
                                        new Date().setDate(
                                            new Date().getDate() - 42
                                        )
                                    )
                                }
                                isAvailable={WechselterminAvailableDate}
                            />
                        </NewFormRow.Value>
                    </NewFormRow>

                    {hasFormErrorAt("delivery_change_date") && (
                        <FormError
                            className={""}
                            message={"Geben Sie bitte eine Datum."}
                        />
                    )}
                </>
            )}
            {deliveryDetails.delivery_movement_type ===
                "Lieferantenwechsel" && (
                <>
                    <NewFormRow>
                        <NewFormRow.Label>
                            Bisheriger Lieferant
                        </NewFormRow.Label>
                        <NewFormRow.Value>
                            <NewInput
                                placeholder="Bisheriger Lieferant"
                                name="delivery_previous_supplier"
                                onChange={handleChange}
                                value={
                                    deliveryDetails.delivery_previous_supplier
                                }
                                validation="company"
                                forceError={hasFormErrorAt(
                                    "delivery_previous_supplier"
                                )}
                                onError={() =>
                                    addFormError("delivery_previous_supplier")
                                }
                                onErrorSolved={() =>
                                    clearFormError("delivery_previous_supplier")
                                }
                            />
                        </NewFormRow.Value>
                    </NewFormRow>

                    <NewFormRow>
                        <NewFormRow.Label>Wechseltermin</NewFormRow.Label>
                        <NewFormRow.Value>
                            <NewSelect
                                name="delivery_change_date_immediately"
                                onChange={selectSupplierTypeHandleChange}
                                options={[
                                    {
                                        value: "nächstmöglich",
                                        text: "nächstmöglich",
                                    },
                                    {
                                        value: "frühestens",
                                        text: "frühestens zum (Datum*)",
                                    },
                                ]}
                            />
                        </NewFormRow.Value>
                    </NewFormRow>

                    {deliveryDetails.delivery_change_date_immediately ===
                        "frühestens" && (
                        <>
                            <NewFormRow>
                                <NewFormRow.Label>
                                    Gewünschter Wechseltermin
                                </NewFormRow.Label>
                                <NewFormRow.Value>
                                    <DatePicker
                                        label="(Datum*) hier eintragen"
                                        placeholderText={"tt.mm.jjjj"}
                                        value={
                                            deliveryDetails.delivery_change_date
                                        }
                                        onChange={onChangeMovementDateChSuDate}
                                        maxDate={null}
                                        minDate={
                                            new Date(
                                                new Date().setDate(
                                                    new Date().getDate() + 14
                                                )
                                            )
                                        }
                                        isAvailable={
                                            lieferantelwechselAvailableDate
                                        }
                                    />
                                </NewFormRow.Value>
                            </NewFormRow>
                            {hasFormErrorAt(
                                "delivery_supplier_terminated_date"
                            ) && (
                                <FormError
                                    className={""}
                                    message={"Geben Sie bitte eine Datum."}
                                />
                            )}
                        </>
                    )}
                </>
            )}
            <section>
                <NewFormRow>
                    <NewFormRow.Label>
                        Kündigung des bisherigen Vertrages:
                    </NewFormRow.Label>
                    <NewFormRow.Value>
                        <NewSelect
                            name="delivery_supplier_terminated"
                            onChange={selectTerminateSupplierHandleChange}
                            value={deliveryDetails.delivery_supplier_terminated}
                            options={[
                                {
                                    value: "NeinTS",
                                    text: "Nein, automatische Kündigung",
                                },
                                {
                                    value: "JaTS",
                                    text: "Ja, ich habe gekündigt",
                                },
                            ]}
                        />
                    </NewFormRow.Value>
                </NewFormRow>

                {deliveryDetails.delivery_supplier_terminated === "JaTS" && (
                    <React.Fragment>
                        <NewFormRow>
                            <NewFormRow.Label>
                                Gewünschter Wechseltermin
                            </NewFormRow.Label>
                            <NewFormRow.Value>
                                <DatePicker
                                    placeholderText={"Kündigungsdatum"}
                                    label="Kündigungsdatum"
                                    value={
                                        deliveryDetails.delivery_supplier_terminated_date
                                    }
                                    onChange={onChangeTerminateSupplierDate}
                                    maxDate={null}
                                    minDate={
                                        new Date(
                                            new Date().setDate(
                                                new Date().getDate() + 14
                                            )
                                        )
                                    }
                                    isAvailable={
                                        lieferantelwechselAvailableDate
                                    }
                                />
                            </NewFormRow.Value>
                        </NewFormRow>

                        {hasFormErrorAt(
                            "delivery_supplier_terminated_date"
                        ) && (
                            <FormError
                                message={"Geben Sie bitte eine Datum."}
                            />
                        )}
                    </React.Fragment>
                )}
            </section>
            <section>
                <NewFormRow>
                    <NewFormRow.Label>Aktionscode:</NewFormRow.Label>
                    <NewFormRow.Value>
                        <NewInput
                            placeholder="Aktionscode"
                            name="aktionscode"
                            onChange={handleChange}
                            value={deliveryDetails.aktionscode}
                            validation="promotion-code"
                            forceError={hasFormErrorAt("aktionscode")}
                            onError={() => addFormError("aktionscode")}
                            onErrorSolved={() => clearFormError("aktionscode")}
                        />
                    </NewFormRow.Value>
                </NewFormRow>
            </section>
        </React.Fragment>
    );
};

export default StepDeliveryDetails;
